import { BaseError } from '@webapp/core/utils/errors/BaseError'

type ERRORS =
  | 'DUPLICATE_REQUIRE_CONFIRMATION_TO_OVERWRITE_DRAFT'
  | 'FETCH_DRAFTS_FAILED'
  | 'EXPENSE_SUBMIT_OVER_BUDGET_CONFIRMATION_REQUIRED'
  | 'EXPENSE_SUBMIT_OVER_BUDGET'
  | 'EXPENSE_APPROVE_OVER_BUDGET_CONFIRMATION_REQUIRED'
  | 'EXPENSE_APPROVE_OVER_BUDGET'

export class ExpenseUseCaseErrors extends BaseError<ERRORS> {}
